import axios from 'axios';
import { API_URL } from '@/config';

export default {

  post() {
    return axios.post(`${API_URL}/cgu`);
  },

  get() {
    return axios.get(`${API_URL}/cgu`);
  },
  // download() {
  //   return `${API_URL}/cgu`;
  // }
};
